class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

   const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static reinitializeCustomScripts() {
    function descriptionWrapper() {
    const button = document.getElementById('toggle-button');
    if (button) {
      const content = document.querySelector('.collection-hero__description');
      const svg = document.querySelector('.description-wrapper .action_button svg')
      if (content.scrollHeight > 150) {
        button.style.display = "block";
      }
      button.closest('.action_button').addEventListener('click', function() {
        if (button.innerText.toLowerCase().includes("read more")) {
          content.style.maxHeight = content.scrollHeight + "px";
          button.innerText = button.innerText.replace("More", "Less");
          svg.style.transform = 'rotate(180deg)';
        } else if (button.innerText.toLowerCase().includes("read less")) {
          content.style.maxHeight = "150px";
          button.innerText = button.innerText.replace("Less", "More");
          svg.style.transform = 'none';

        }
      });

    }
  }

  descriptionWrapper()

    function updatePrices() {
  const startingAtElements = document.querySelectorAll('#product-grid .starting-at');


      // Update the DOM elements with the fetched prices
      startingAtElements.forEach(startingAtElement => {
        let productHandle = startingAtElement.dataset.handle;
        const allProducts = JSON.parse(localStorage.getItem('storedProductPriceArray'))
        const lowestPrice = allProducts.find(product => product.productHandle === productHandle)?.lowestPrice
        if (lowestPrice) {
          startingAtElement.innerHTML = `Starting at $${lowestPrice.toFixed(2)}`;
        } else {
          startingAtElement.innerHTML = "Price unavailable";
        }
      });
}



    updatePrices()
    const filterWrapper = document.getElementById('main-collection-filters');
        const productsGrid = document.querySelector('#ProductGridContainer #product-grid');
        const productCount = Number(productsGrid.children.length); // Ensure product count is converted to a number

        if (filterWrapper.classList.contains('hidden')) {
          productsGrid.classList.remove('grid--3-col-desktop');
          productsGrid.classList.add('grid--4-col-desktop');
        } else {
          productsGrid.classList.remove('grid--4-col-desktop');
          productsGrid.classList.add('grid--3-col-desktop');
        }
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;


       const selectedValue = document.querySelector('.facet-filters__sort').value;
        if (['price-ascending','price-descending','brand-a-z', 'brand-z-a', 'color-a-z', 'color-z-a', 'size-s-l', 'size-l-s', 'shape-a-z', 'shape-z-a'].includes(selectedValue)) {
          const sortedHtml = FacetFiltersForm.sortByMetafields(html, selectedValue);
          FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { sortedHtml, url }];
          FacetFiltersForm.renderFilters(sortedHtml, event);
          FacetFiltersForm.renderProductGridContainer(sortedHtml);
          FacetFiltersForm.renderProductCount(sortedHtml);
          FacetFiltersForm.reinitializeCustomScripts();
          if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(sortedHtml.innerHTML);
        } else {
          FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
          FacetFiltersForm.renderFilters(html, event);
          FacetFiltersForm.renderProductGridContainer(html);
          FacetFiltersForm.renderProductCount(html);
          FacetFiltersForm.reinitializeCustomScripts();
          if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
        }

      });
  }

  static sortByMetafields(html, selectedValue) {

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const productGridContainer = doc.getElementById('product-grid');

    if (!productGridContainer) {
        console.error('Product grid container not found');
        return html;
    }

    const htmlProducts = Array.from(productGridContainer.querySelectorAll('.grid__item'));

    // Helper function to parse sizes
    const parseSize = (size) => {
      if (!size) return size;

      const numericRegex = /[+-]?\d+(\.\d+)?/g;
      const numericValues = size.match(numericRegex);

      if (numericValues) {
        return numericValues.map(parseFloat).reduce((a, b) => a * 1000 + b, 0); // Combines values to create a comparable number
      }

      // Handle other size values, e.g., S, M, L
      const sizeOrder = ['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl', 'one size'];
      const sizeLower = size.toLowerCase();
      const index = sizeOrder.indexOf(sizeLower);
      return index === -1 ? sizeLower : index;
    };
    const metafieldName = selectedValue.split('-')[0];

    // Sort the HTML products array based on the selected metafield
    htmlProducts.sort((a, b) => {
      // Retrieve product handle from each HTML product
      const aHandle = a.querySelector('.card-wrapper').dataset.handle;
      const bHandle = b.querySelector('.card-wrapper').dataset.handle;

      // Find corresponding product metafield objects
      const aMetafield = window.collection_products_metafields.find(product => product.productData.handle === aHandle);
      const bMetafield = window.collection_products_metafields.find(product => product.productData.handle === bHandle);

      // Extract metafield values for comparison
      let aValue = aMetafield && aMetafield.productMetafields[metafieldName] ? aMetafield.productMetafields[metafieldName] : null;
      let bValue = bMetafield && bMetafield.productMetafields[metafieldName] ? bMetafield.productMetafields[metafieldName] : null;

      // Special handling for sizes
      if (selectedValue.startsWith('size')) {
        aValue = parseSize(aValue);
        bValue = parseSize(bValue);
      }
      if (selectedValue.startsWith('price')) {
        const storedProducts = JSON.parse(localStorage.getItem('storedProductPriceArray'))
        const aProduct = storedProducts?.find(product => product.productHandle == aHandle)
        const bProduct = storedProducts?.find(product => product.productHandle == bHandle)

        aValue = aProduct && aProduct.lowestPrice !== null ? aProduct.lowestPrice : Infinity;
        bValue = bProduct && bProduct.lowestPrice !== null ? bProduct.lowestPrice : Infinity;

        if (selectedValue.endsWith('-ascending')) { // Ascending order
                if (aValue < bValue) return -1;
                if (aValue > bValue) return 1;
            } else { // Descending order
                if (aValue < bValue) return 1;
                if (aValue > bValue) return -1;
            }
      }
      // If values are null, they should go to the end
      if (aValue === null && bValue !== null) return 1;
      if (aValue !== null && bValue === null) return -1;
      if (aValue === null && bValue === null) return 0;


      if (selectedValue === 'color-a-z' || selectedValue === 'color-z-a') {
        aValue = aValue.toLowerCase();
        bValue = bValue.toLowerCase();
        if (selectedValue === 'color-z-a') {
          return bValue.localeCompare(aValue);
        }
        return aValue.localeCompare(bValue);
      }
      if (metafieldName === 'brand' || metafieldName === 'shape') {
        aValue = aValue.toLowerCase();
        bValue = bValue.toLowerCase();
        if (selectedValue === 'brand-a-z' || selectedValue === 'shape-a-z') {
          return aValue.localeCompare(bValue);
        }
        return bValue.localeCompare(aValue);
      }

      // General sorting for other metafields (including ascending/descending logic for sizes)
      if (selectedValue.endsWith('s-l')) {
            if (aValue < bValue) return -1;
            if (aValue > bValue) return 1;
        } else {
            if (aValue < bValue) return 1;
            if (aValue > bValue) return -1;
        }
        return 0;
    });

    // Clear the existing content of the product grid container
    productGridContainer.innerHTML = '';

    // Append sorted products back to the product grid container
    htmlProducts.forEach(product => {
      productGridContainer.appendChild(product);
    });

    // Serialize the document back to a string
    return doc.documentElement.outerHTML;
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    const sortedHtml = FacetFiltersForm.filterData.find(filterDataUrl).sortedHtml
    if (sortedHtml) {

    FacetFiltersForm.renderFilters(sortedHtml, event);
    FacetFiltersForm.renderProductGridContainer(sortedHtml);
    FacetFiltersForm.renderProductCount(sortedHtml);
      FacetFiltersForm.reinitializeCustomScripts();
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(sortedHtml.innerHTML);
    } else if (html) {
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
      FacetFiltersForm.reinitializeCustomScripts();
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
    }


  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };
    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);
        if (newElementToActivate) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
